import React from 'react';

import cx from 'classnames';

import { IText } from './interface';

type Dictionary<T> = Partial<{ [key: string]: T }>;

/**
 * Typography component, extends base HTML element properties
 */
const Text: React.FC<IText> = ({ component, variant = 'body1', className, children, ...props }) => {
  const Component =
    component ||
    (
      {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
        button: 'span',
      } as Dictionary<string>
    )[variant] ||
    'p';

  const variantClasses = (
    {
      h1: 'text-h1 leading-normal font-medium tracking-tight',
      h2: 'text-h2 leading-normal font-medium tracking-tight',
      h3: 'text-h3 leading-normal font-medium tracking-tight',
      h4: 'text-h4 leading-normal font-medium tracking-tight',
      h5: 'text-h5 leading-normal font-medium tracking-tight',
      h6: 'text-h6 leading-normal font-medium',
      subtitle1: 'text-lead font-medium leading-normal',
      subtitle2: 'text-base font-medium leading-normal',
      body1: 'text-base leading-normal',
      body2: 'text-small leading-normal',
      button: 'font-medium leading-normal',
      caption: 'text-micro leading-normal',
      overline: 'text-nano leading-normal',
    } as Dictionary<string>
  )[variant];

  return React.createElement(
    Component,
    {
      className: cx('nord-text', variantClasses, className),
      ...props,
    },
    children
  );
};

export default Text;
